import Product from '~/js/models/product'

/**
 * OSProductは、FF Services 商品検索APIから取得した商品データを扱うためのクラスです。
 * OpenSearch APIのレスポンス形式に基づいて、必要なプロパティを定義しています。
 * OS = OpenSearchの略
 */
export default class OSProduct extends Product {
  constructor(product = {}) {
    super(product)
    const variant = product.variants[0]

    this.sku = product.handle
    this.productImage = product.images?.[0]?.url || ''
    this.productType = product.product_type || ''
    this.variantId = variant.id
    this.price = variant.price
    this.comparePrice = variant.compare_at_price
    this.comparePriceMin = this.productType.includes('オーダーカーテン')
      ? null
      : Math.min(...product.variants.map((v) => v.compare_at_price))
    this.priceMin = Math.min(...product.variants.map((v) => v.price))
  }
}
